import { render } from "./CreateUserSimple.vue?vue&type=template&id=8fac010a"
import script from "./CreateUserSimple.vue?vue&type=script&lang=js"
export * from "./CreateUserSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__